import React from 'react';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';

const cpeTables = [
  {
    label: 'Universe Table 1',
    short: 'COA',
    description: 'Compliance Oversight Activities',
    universeType: 'cpe_coa',
    gradient: 'from-emerald-500 to-teal-500',
    icon: ShieldCheckIcon,
    color: 'emerald'
  }
];

export default function CPETableSelector({ onSelect }) {
  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-slate-900 mb-2">Choose Universe Table</h2>
        <p className="text-slate-600">Select the specific universe table for your analysis</p>
      </div>

      <div className="grid gap-6 max-w-2xl mx-auto">
        {cpeTables.map((table, index) => {
          const Icon = table.icon;
          return (
            <button
              key={index}
              onClick={() => onSelect(table)}
              className="
                group relative w-full text-left
                bg-white/90 backdrop-blur-2x1
                rounded-3xl p-8
                border border-slate-200/60
                shadow-lg shadow-slate-200/50
                hover:shadow-xl hover:shadow-slate-300/60
                hover:-translate-y-1 hover:scale-[1.01]
                transition-all duration-300 ease-out
                focus:outline-none focus:ring-4 focus:ring-emerald-500/30 focus:ring-offset-4 focus:ring-offset-white
                overflow-hidden
              "
            >
              {/* Content */}
              <div className="relative z-10">
                {/* Header with icon and badges */}
                <div className="flex items-start justify-between mb-6">
                  <div className={`
                    h-16 w-16 rounded-2xl bg-gradient-to-br ${table.gradient}
                    shadow-lg shadow-emerald-500/25
                    flex items-center justify-center
                    group-hover:scale-105
                    transition-all duration-300 ease-out
                  `}>
                    <Icon className="h-8 w-8 text-white" />
                  </div>
                  
                  <div className="flex flex-col items-end gap-2">
                    <span className="px-3 py-1.5 bg-slate-100/90 backdrop-blur-xl text-slate-700 text-sm font-semibold rounded-lg border border-slate-200/60">
                      {table.short}
                    </span>
                    <span className="px-3 py-1.5 bg-gradient-to-r from-emerald-100/90 to-teal-100/90 backdrop-blur-xl text-emerald-700 text-xs font-semibold rounded-lg border border-emerald-200/60">
                      Universe
                    </span>
                  </div>
                </div>

                {/* Title and description */}
                <div className="mb-6">
                  <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-emerald-800 transition-colors duration-300">
                    {table.label}
                  </h3>
                  <p className="text-slate-600 text-sm">
                    {table.description}
                  </p>
                </div>

                {/* Action footer */}
                <div className="flex items-center justify-between pt-4 border-t border-slate-200/60">
                  <span className="text-emerald-600 font-semibold text-sm group-hover:text-emerald-700 transition-colors duration-300 underline">
                    Select Table
                  </span>
                  <div className="w-8 h-8 rounded-lg bg-slate-100/90 backdrop-blur-xl flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 group-hover:scale-110 border border-slate-200/60">
                    <svg className="w-4 h-4 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </div>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
